<template>
<div class="content work_wrapper search_content analysis">
        <v-row class="search_box">
            <v-col>
              <searchBar @getKey="getKey" @watchSaDialog="watchSaDialog" :openSaveDialog="openSaveDialog" :proInfo="proInfo"></searchBar>
            </v-col>
        </v-row>
        <div class="conter_outer1">
            <div class="conter_outer_tops" v-if="currentName">
                <div class="top_left" @click="goBack">
                    <i class="icon"></i>
                    <span class="name">{{currentName}}</span>
                    <span class="desc"></span>
                </div>
                <div class="top_right">
                    <span class="btn" @click="saveRation">保存</span>
                </div>
            </div>
            <v-row>
                <v-col sm="12" md="3" lg="2" class="left_side_outer" :class="{'d-none': collapse}">
                    <analyLeft @setAnalyFilterKey="analyFilter" @setAnalySecKey="analySecKey"></analyLeft>
                </v-col>
                <v-col sm="12" :md="layoutRight" lg="10" class="right_side_outer1">
                    <div class="right_side_outer fix_icon_wrapper">
                        <div v-if="!collapse" class="fixed_icon hand hidden-xs-only" @click="handleLeft">
                            <v-icon>mdi-chevron-double-left</v-icon>
                        </div>
                        <div v-if="collapse" class="fixed_icon1 hand hidden-xs-only" @click="handleLeft">
                            <v-icon>mdi-chevron-double-right</v-icon>
                        </div>
                        <div v-if="!collapse" class="fixed_icon iphone_icon hand d-md-none" @click="handleLeft">
                            <v-icon>mdi-chevron-double-left</v-icon>
                        </div>
                        <div v-if="collapse" class="fixed_icon1 iphone_icon hand d-md-none" @click="handleLeft">
                            <v-icon>mdi-chevron-double-right</v-icon>
                        </div>
                        <div class="right_side">
                            <v-row class="nav_top_btns">
                                <v-col xs="12">
                                    <div class="btns_list">
                                        <div class="flex_style left">
                                            <span v-if="fieldLabel!='概览分析'" class="back_name" @click="goOutline">&lt;返回概览分析</span>
                                            <span v-else class="back_name1">{{fieldLabel}}</span>
                                            <!-- <div class="name1" v-if="currentName">项目： {{currentName}}</div> -->
                                            <!-- <div class="name" v-if="fieldLabel">{{fieldLabel}}</div> -->
                                        </div>
                                        <div class="flex_style right_nav_btn">
                                            <JsonExcel v-if="multiple == '1'&&fieldLabel&&fieldLabel!='概览分析'" class="export-excel-wrapper" :data="data.total" :fields="json_fields" :name="fieldLabel+'.xls'">
                                            <div class="item_btn">
                                                <div class="icon"></div>
                                                    <span>导出</span>
                                                    <!-- <el-button type="primary" size="small" class="buttonCss">导出</el-button> --> 
                                            </div>
                                            </JsonExcel>
                                            <JsonExcel v-if="multiple == '2'&&fieldLabel&&fieldLabel!='概览分析'" class="export-excel-wrapper" :data="excelTable" :fields="json_fields1" :name="fieldLabel+'.xls'">
                                            <div class="item_btn">
                                                <div class="icon"></div>
                                                    <span>导出</span>
                                            </div>
                                            </JsonExcel>
                                            <div class="item_btn grey1"  v-if="outLine" @click="goSetting">
                                                <v-icon>mdi-cog</v-icon>
                                                <span>设置</span>
                                            </div>
                                            <!-- <div class="btn_item hand" v-if="outLine" @click="goSetting">
                                                <v-icon>mdi-cog</v-icon>
                                            </div>
                                            <div class="btn_item hand" title="保存的项目" @click="goProList">
                                                <v-icon>mdi-file-cabinet</v-icon>
                                            </div>
                                            <div class="btn_item hand">
                                                <v-icon>mdi-download</v-icon>
                                            </div> -->
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col sm="12">
                                    <div class="chart_List" v-show="outLine">
                                        <div class="chartDom" id="chart_List0"></div>
                                        <div class="chartDom" id="chart_List1"></div>
                                        <div class="chartDom" id="chart_List2"></div>
                                        <div class="chartDom" id="chart_List3"></div>
                                        <div class="chartDom" id="chart_List4"></div>
                                        <div class="chartDom" id="chart_List5"></div>
                                    </div>
                                    <div class="analyse_Class" v-show="!outLine">
                                        <div class="left_side_cons">
                                            <div class="flex_style betw top_title">
                                                <div class="title">{{fieldLabel}}</div>
                                                <div class="class_btns">
                                                    <div :class="{'items_icon': true,'active': this.fieldDefault == 'lineChart'}"  @click="lineChart"><i class="icon line"></i></div>
                                                    <div :class="{'items_icon': true,'active': this.fieldDefault == 'barChart'}" @click="barChart" ><i class="icon bar"></i></div>
                                                    <div :class="{'items_icon': true,'active': this.fieldDefault == 'pieChart'}" v-if="multiple == 1" @click="pieChart"><i class="icon pie"></i></div>
                                                    <div :class="{'items_icon': true,'active': this.fieldDefault == 'insideBar'}" v-if="multiple == 1" @click="insideBar"><i class="icon inside"></i></div>
                                                    <div :class="{'items_icon': true,'active': this.fieldDefault == 'table'}" @click="showTables"><i class="icon table"></i></div>
                                                    <!-- <v-icon :class="{'active': this.fieldDefault == 'lineChart'}" @click="lineChart">mdi-chart-line</v-icon>
                                                    <v-icon :class="{'active': this.fieldDefault == 'barChart'}" @click="barChart">mdi-chart-bar</v-icon>
                                                    <v-icon :class="{'active': this.fieldDefault == 'pieChart'}" v-if="multiple == 1" @click="pieChart">mdi-chart-arc</v-icon>
                                                    <v-icon :class="{'active': this.fieldDefault == 'insideBar'}" v-if="multiple == 1" @click="insideBar">mdi-chart-gantt</v-icon> -->
                                                    <!-- <v-icon @click="showTable = true">mdi-table</v-icon> -->
                                                </div> 
                                            </div>
                                            <div class="class_echart" v-show="!showTable" id="chart_class"></div>
                                            <div v-show="showTable">
                                                <div class="class_table" v-if="multiple == '1'">
                                                    <div class="tb_header">
                                                        <div class="tr">
                                                            <div class="td" v-if="fieldKey.indexOf('applicationYear') >-1 || fieldKey.indexOf('publicationYear') >-1">年份</div>
                                                            <div class="td" v-else-if="fieldKey.indexOf('level')>-1">专利价值评级</div>
                                                            <div class="td" v-else-if="fieldKey =='applicant'">申请人</div>
                                                            <div class="td" v-else-if="fieldKey =='applicantType'">申请人类型</div>
                                                            <div class="td" v-else-if="fieldKey =='inventor'">发明人</div>
                                                            <div class="td" v-else-if="fieldKey.indexOf('country')>-1">地域</div>
                                                            <div class="td" v-else-if="fieldKey =='type'">专利类型</div>
                                                            <div class="td" v-else-if="fieldKey =='province'">省份</div>
                                                            <div class="td" v-else-if="fieldKey =='city'">地市</div>
                                                            <div class="td" v-else-if="fieldKey =='currentStatus'">法律状态</div>
                                                            <div class="td" v-else-if="fieldKey =='legalStatus'">有效性</div>
                                                            <div class="td" v-else-if="fieldKey.indexOf('exeDate')>-1">年份</div>
                                                            <div class="td" v-else-if="fieldKey.indexOf('pre_2')>-1">转让人</div>
                                                            <div class="td" v-else-if="fieldKey.indexOf('after_2')>-1">受让人</div>
                                                            <div class="td" v-else-if="fieldKey.indexOf('pre_3')>-1">许可人</div>
                                                            <div class="td" v-else-if="fieldKey.indexOf('after_3')>-1">被许可人</div>
                                                            <div class="td" v-else-if="fieldKey.indexOf('pre_4')>-1">出质人</div>
                                                            <div class="td" v-else-if="fieldKey.indexOf('after_4')>-1">质权人</div>
                                                            <div class="td" v-else-if="fieldKey.indexOf('accuser')>-1">诉讼当事人</div>
                                                            <div class="td" v-else-if="fieldKey.indexOf('wxPerson')>-1">无效请求人</div>
                                                            <div class="td" v-else-if="fieldKey.indexOf('fsPerson')>-1">复审请求人</div>
                                                            <div class="td" v-else-if="fieldKey =='agency'">代理机构</div>
                                                            <div class="td" v-else-if="fieldKey =='agent'">代理人</div>       
                                                            <div class="td" v-else>IPC分类</div>
                                                            <div class="td">专利数</div>
                                                        </div>
                                                    </div>
                                                    <div class="td_body">
                                                        <div class="tr" v-for="(item,index) in data.total"  :key="index">
                                                            <div class="td">{{item.key}}</div>
                                                            <div class="td">{{item.value}}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="class_table" v-if="multiple == '2'">
                                                    <table>
                                                        <thead class="tb_header">
                                                            <tr class="tr">
                                                                <th class="td" v-if="fieldKey.indexOf('applicationYear') >-1">申请日</th>
                                                                <th class="td" v-else-if="fieldKey.indexOf('publicationYear')>-1">公开日</th>
                                                                <th class="td" v-else-if="fieldKey.indexOf('countryCode')>-1&&fieldKey !='countryCode-ipc3'">国家</th>
                                                                <th class="td" v-else-if="fieldKey.indexOf('province')>-1">省份</th>
                                                                <th class="td" v-else-if="fieldKey.indexOf('city')>-1">地市</th>
                                                                <th class="td" v-else-if="fieldKey =='applicant-level'">申请人</th>
                                                                <th class="td" v-else-if="fieldKey =='countryCode-ipc3'">IPC分类</th>
                                                                <th class="td" v-else>IPC分类</th>
                                                                <th class="td" v-for="(item,index) in tableData" :key="index">
                                                                    {{item.key}}
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody class="td_body">
                                                            <tr class="tr" v-for="item in tableTd" :key="item">
                                                                <td class="td">{{item}}</td>
                                                                <td class="td" v-for="(item1,index) in tableData" :key="index">
                                                                    <span v-if="item1.value[item]">{{item1.value[item]}}</span>
                                                                    <span v-else>0</span>
                                                                    <!-- {{item1.value}} -->
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="right_side_cons">
                                            <div class="right_side_list">
                                                <div class="item_list" v-if="ipcList&&ipcList.length>0">
                                                    <div class="title1">IPC分类</div>
                                                    <div class="flex_style left title_line">
                                                        <v-checkbox
                                                            v-model="selAll"
                                                            :indeterminate="isIndeter"
                                                        >
                                                        </v-checkbox>
                                                        <span>全选</span>
                                                    </div>
                                                    <div :class="{'ipcList_item':true, 'vh30': multiple == 2}">
                                                        <v-list dense>
                                                            <v-list-item-group
                                                            v-model="ipcKeys"
                                                            multiple
                                                            color="primary"
                                                            >
                                                            <v-card v-for="item in ipcList" :key="item.code" class="item">
                                                                <div class="icon">
                                                                    <v-list-item  :value="item.code" >
                                                                        <template v-slot:default="{active}">
                                                                            <v-checkbox :input-value="active"  color="primary"></v-checkbox>
                                                                            <span class="line_name">{{item.code}} {{item.name}}</span>
                                                                        </template>
                                                                    </v-list-item>
                                                                </div>
                                                            </v-card>
                                                            </v-list-item-group>
                                                        </v-list>
                                                    </div>
                                                </div>
                                                <div class="item_list" v-if="multipleType&&multipleType.length>0">
                                                    <div class="flex_style left title_line">
                                                        <v-checkbox
                                                            v-model="selAll1"
                                                            :indeterminate="isIndeter1"
                                                        >
                                                        </v-checkbox>
                                                        <span>全选</span>
                                                    </div>
                                                    <div :class="{'ipcList_item':true, 'vh30': multiple == 2}">
                                                        <v-list dense>
                                                            <v-list-item-group
                                                            v-model="typesKeys"
                                                            multiple
                                                            color="primary"
                                                            >
                                                            <v-card v-for="(item,index) in multipleType" :key="index" class="item">
                                                                <div class="icon">
                                                                    <v-list-item  :value="item" >
                                                                        <template v-slot:default="{active}">
                                                                            <v-checkbox :input-value="active"  color="primary"></v-checkbox>
                                                                            <span class="line_name">{{item}}</span>
                                                                        </template>
                                                                    </v-list-item>
                                                                </div>
                                                            </v-card>
                                                            </v-list-item-group>
                                                        </v-list>
                                                    </div>
                                                </div>
                                                <div class="yearChange_item" v-if="fieldKey.indexOf('applicationYear') >-1 || fieldKey.indexOf('publicationYear') >-1">
                                                    <v-radio-group v-model="timeKeys">
                                                        <div class="radio_item">
                                                            <v-radio
                                                                label="所有"
                                                                value="all"
                                                            ></v-radio>
                                                        </div>
                                                        <div class="radio_item" v-if="multipleXAxis&&multipleXAxis.length>19 || this.data.xAxis&&this.data.xAxis.length>19">
                                                            <v-radio
                                                                label="近20年"
                                                                value="20"
                                                            ></v-radio>
                                                        </div>
                                                        <div class="radio_item" v-if="multipleXAxis&&multipleXAxis.length>9 || this.data.xAxis&&this.data.xAxis.length>9">
                                                            <v-radio
                                                                label="近10年"
                                                                value="10"
                                                            ></v-radio>
                                                        </div>
                                                        <div class="radio_item flex_style left">
                                                            <v-radio
                                                                label=""
                                                                value="custom">
                                                            </v-radio>
                                                            <div class="input_width">
                                                            <v-text-field
                                                                hide-details
                                                                outlined
                                                                placeholder="年份"
                                                                v-model="time1"
                                                                @focus="timeKeys = 'custom'"
                                                            ></v-text-field>
                                                            </div>
                                                            <span class="to_name">TO</span>
                                                            <div class="input_width">
                                                                <v-text-field
                                                                    hide-details
                                                                    outlined
                                                                    placeholder="年份"
                                                                    v-model="time2"
                                                                    @focus="timeKeys = 'custom'"
                                                                ></v-text-field>
                                                            </div>
                                                        </div>
                                                    </v-radio-group>
                                                </div>
                                                <div class="item_list" v-else-if="fieldKey!='ipc3'&&fieldKey!='mainIpc3'">
                                                    <div class="flex_style left title_line">
                                                        <v-checkbox
                                                            v-model="selAll2"
                                                            :indeterminate="isIndeter2"
                                                        >
                                                        </v-checkbox>
                                                        <span>全选</span>
                                                    </div>
                                                    <div :class="{'ipcList_item':true, 'second': true, 'vh30': multiple == 2}">
                                                        <v-list dense>
                                                            <v-list-item-group
                                                            v-model="xAxisKeys"
                                                            multiple
                                                            color="primary"
                                                            >
                                                            <v-card v-for="(item,index) in multipleXAxis" :key="index" class="item">
                                                                <div class="icon">
                                                                    <v-list-item  :value="item" >
                                                                        <template v-slot:default="{active}">
                                                                            <v-checkbox :input-value="active"  color="primary"></v-checkbox>
                                                                            <span class="line_name">{{item}}</span>
                                                                        </template>
                                                                    </v-list-item>
                                                                </div>
                                                            </v-card>
                                                            </v-list-item-group>
                                                        </v-list>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="right_side_btn" @click="filterChartData">
                                                <span>分析</span>
                                            </div>
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </div>
        <div class="analy_fixed_wrapper" v-if="status=='2'&&stepNum != 4">
            <div class="analy_fixed_content">
                <div class="analy_tips_box box1" v-if="stepNum == 1">
                    <div class="pfont">您可以更改检索式或者关键词，重新进行数据分析。</div>
                    <div class="flex_style betw">
                        <div class="icon_line"></div>
                        <div class="icon_btn" @click="stepNum++">我知道了</div>
                    </div>
                </div>
                <div class="analy_tips_box box2" v-if="stepNum == 2">
                    <div class="pfont">您可以通过“分析”、“过滤”，完成多维度筛选图表、过滤关键词的操作</div>
                    <div class="flex_style betw">
                        <div class="icon_line"></div>
                        <div class="icon_btn" @click="stepNum++">我知道了</div>
                    </div>
                </div>
                <div class="analy_tips_box box3" v-if="stepNum == 3">
                    <div class="pfont">您可以根据自身需求导出pdf分析报告</div>
                    <div class="flex_style betw">
                        <div class="icon_line"></div>
                        <div class="icon_btn" @click="stepOver">我知道了</div>
                    </div>
                </div>
                <div class="analy_tips_box box4" v-if="stepNum == 5">
                    <div class="pfont">您可以在左边分析的基础上，继续细分筛选维度进行数据分析</div>
                    <div class="flex_style betw">
                        <div class="icon_line"></div>
                        <div class="icon_btn" @click="stepOver">我知道了</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import searchBar from "@/components/side/searchBar.vue";
import analyLeft from "@/components/analyse/analyLeft.vue";
import echarts from "echarts";
import { mapState, mapActions } from 'vuex';
import {dataTransLate} from '@/assets/js/mapFormat.js'
import JsonExcel from 'vue-json-excel';
export default {
    data() {
        return {
            stepNum: 4,
            layoutRight: 9,
            collapse: false,
            text: '',
            multiple: '1',
            columnKey: '',
            fieldKey: '',
            myChart: '',
            name: '',
            chartOption: {},
            lineOption: {},
            barOption: {},
            pieOption: {},
            data: {
                'xAxis': [],
                'legend': [],
                'num': [120, 200, 150, 80, 70, 110, 130],
                'total': []
            },
            newData: {},
            str: '',
            fc: '',
            currentName: '',
            proId: '',
            wfId: '',
            ipcList: [],
            ipcKeys: [],
            timeKeys: '',
            time1: '',
            time2: '',
            totalData: [],
            totalData1: [],
            isIndeter: false,
            selAll: false,
            multipleType: [],
            multipleXAxis: [],
            typesKeys: [],
            isIndeter1: false,
            selAll1: false,
            xAxisKeys: [],
            isIndeter2: false,
            selAll2: false,
            tableData: [],
            tableTd: [],
            showTable: false,
            outLine: false,
            fieldLabel: '',
            outLineInfo: {},
            chartList: [],
            fieldDefault: '',
            openSaveDialog: false,
            projectId: '',
            json_fields: { 
                "年份": 'key',
                "专利数": 'value'
            },
            json_fields1: { 
                "年份": 'year',
            },
            cover: '',
            proInfo: '',
            q2: '',
            excelTable: [],
            status: ''
        }
    },
    created() {
        if(this.$vuetify.breakpoint.name=='sm' || this.$vuetify.breakpoint.name == 'xs') {
            this.collapse = true
        }
        // this.$store.commit('setMenuMini', false)
    },
    mounted() {
        let name = this.$route.params.id
        let status = this.$route.query.status
        this.status = status
        this.projectId = name
        if(status == '2') {
            localStorage.setItem('stepNum',1)
        }
        if(localStorage.getItem('stepNum')) {
            setTimeout(() => {
                this.stepNum = localStorage.getItem('stepNum')
            }, 2000); 
        }
        if(this.$route.query.folderId) {
            this.wfId = this.$route.query.folderId
            this.$store.commit('setAnalyFilter',[])
            sessionStorage.setItem('analyFilterData','')
        }
        if(sessionStorage.getItem('analyFilterData')) {    
            this.fc = sessionStorage.getItem('analyFilterData')
        }else {
            this.fc = ''
        }
        if(sessionStorage.getItem('AnalyKey')) {
            let val = JSON.parse(sessionStorage.getItem('AnalyKey'))
            this.columnKey = val[0]
            this.fieldKey = val[1].key
            this.fieldLabel = val[1].label
            this.fieldDefault = val[1].default
        }    
        this.proId = name
        this.str = this.$route.query.str
        this.cover = this.$route.query.cover
        this.initChart()
        if(this.$route.query.spc&&this.$route.query.spc=='project') {
            this.getCurrentPro()
        }
        if(this.proId&&this.proId!='all') {
            this.getRationInfo()
        }else {
            this.getData()
        }
        this.$store.commit('setMenuMini', false)
    },
    components: {
        searchBar,
        analyLeft,
        JsonExcel
    },
    watch: {
        $route(to, from) {
            if(to.path.indexOf('/analyse/classify')>-1) {
                // this.getName(to.params.id)
            }
        },
        analyKey(val) {
            this.columnKey = val[0] || ''
            this.fieldKey = val[1].key || ''
            this.fieldLabel = val[1].label || '概览分析'
            this.fieldDefault = val[1].default || 'lineChart'
            this.getData()
        },
        selAll(val) {
            if(val) {
                let all = this.ipcList.map((item)=>{
                    return item.code
                })
               this.ipcKeys = all
               this.isIndeter = false
            }else {
                this.ipcKeys = []
                this.isIndeter =  false
            }
        },
        selAll1(val) {
            if(val) {
               this.typesKeys = this.multipleType
               this.isIndeter1= false
            }else {
                this.typesKeys = []
                this.isIndeter1 =  false
            }
        },
        selAll2(val) {
            if(val) {
               this.xAxisKeys = this.multipleXAxis
               this.isIndeter2= false
            }else {
                this.xAxisKeys = []
                this.isIndeter2 =  false
            }
        },
        ipcKeys(val) {
            if(val.length<=0) {
                this.isIndeter =  false
                this.selAll = false
            }else if(val.length< this.ipcList.length) {
                this.isIndeter =  true
            }else {
                this.isIndeter =  false
                this.selAll = true
            }
        },
        typesKeys(val) {
            if(val.length<=0) {
                this.isIndeter1 =  false
                this.selAll1 = false
            }else if(val.length< this.multipleType.length) {
                this.isIndeter1 =  true
            }else {
                this.isIndeter1 =  false
                this.selAll1 = true
            }
        },
        xAxisKeys(val) {
            if(val.length<=0) {
                this.isIndeter2 =  false
                this.selAll2 = false
            }else if(val.length< this.multipleXAxis.length) {
                this.isIndeter2 =  true
            }else {
                this.isIndeter2 =  false
                this.selAll2 = true
            }
        }
    },
    computed: {
        ...mapState('analy', {
            totalList: state => state.defauleSearchSchema.defaultFilter
        }),
        analyKey() {
            return this.$store.state.analyKey
        },
    },
    methods: {
        ...mapActions('analy',['analysisData','currentRation','rationInfo']),
        goBack() {
            this.$router.push({
                path: '/analyse'
            })
        },
        stepOver() {
            this.stepNum = 4
            localStorage.setItem('stepNum', this.stepNum)
        },
        showTables() {
            this.fieldDefault = 'table'
            this.showTable = true
        },
        analyFilter(val) {
            if(val) {
                if(this.$store.state.analyFilterData){
                    this.fc = JSON.stringify(this.$store.state.analyFilterData)
                }else if(sessionStorage.getItem('analyFilterData')) {
                    this.fc = sessionStorage.getItem('analyFilterData')
                }
                this.getData()
            }
        },
        analySecKey(val) {
            this.q2 = val
            this.getData()
        },
        getKey(val) {
            this.str = val
            if(val) {
                this.getData()
            }
        },
        handleLeft() {
            this.collapse = !this.collapse
            this.layoutRight = this.collapse? 12: 9
        },
        goProList() {
            this.$router.push({
                path: '/analyse',
                query: {
                    str: this.str
                }
            })
        },
        goSetting() {
            this.$router.push({
                path: '/analyset'
            })
        },
        getCurrentPro() {
            let data = {
                params: {
                    ds: 'cn',
                    q: this.str,
                    fc: this.fc,
                    q2: '',
                    wfId: this.wfId
                }
            }
            let _this = this 
            this.currentRation({data: data,handle(res) {
                if(res.success) {
                    _this.currentName = res.message
                }
                if(_this.status == '2') {
                    _this.currentName = '华为手机'
                }
            }})
        },
        goOutline() {
            let data = ['outline',{key: '',label: '概览分析'}]
            sessionStorage.setItem('AnalyKey', JSON.stringify(data))
            this.$store.commit('setAnalyKey', data)
        },
        getRationInfo() {
            let data = {
                params: {
                    id: this.proId
                }
            }
            let _this  = this
            this.rationInfo({data: data,handle(res) {
                _this.str = res.keywords_q
                // if(_this.status == '2') {
                //     _this.str = '华为手机'
                // }
                _this.wfId = res.wfId || ''
                _this.$store.commit('setAnalyFilter', res.filterConditions || [])
                _this.fc = JSON.stringify(res.filterConditions) || ''
                _this.getData()
            }})
        },
        getOutline() {
            let data = [
                {
                    columnKey: 'trend',
                    key: 'applicationYear',
                    label: '申请趋势'
                },
                {
                    columnKey: 'trend',
                    key: 'publicationYear',
                    label: '公开趋势'
                },
                {
                   columnKey: 'technology',
                   key: 'ipc3',
                   label: '技术构成'
                },
                {
                   columnKey: 'technology',
                   key: 'ipc3-applicationYear',
                   label: '技术申请趋势'
                },
                {
                    columnKey: 'technology',
                    key: 'ipc3-publicationYear',
                    label: '技术公开趋势'
                },
                {
                    columnKey: 'trend',
                    key: 'ipc3-countryCode',
                    label: '技术全球分布'
                }
            ] 
            if(localStorage.getItem('setting')) {
                data = JSON.parse(localStorage.getItem('setting'))
            }
           
           data.forEach((item,index)=>{
               let dom = document.getElementById("chart_List"+index)
               this.getSimpData(item.columnKey,item.key,this.lineChart1,this.chartList[index],dom,item.label)
           })
        },
        getSimpData(columnKey,fieldKey,chartType,mychart,chartDom,name) {
            let field = ''
            let subField = ''
            let ds = 'cn'
            if(fieldKey.indexOf('-')>-1) {
                field = fieldKey.split('-')[0]
                subField = fieldKey.split('-')[1]
            }else {
                field = fieldKey
            }
            if(fieldKey.indexOf("province")>-1 || fieldKey.indexOf("city")>-1 || fieldKey=='type') {
                ds = 'cn'
            }
            let data = {
                params: {
                    column: columnKey,
                    field: field,
                    subField: subField,
                    ipcLevel: '3',
                    wfId: this.wfId,
                    size: '50',
                    subSize: '',
                    m: 'none',
                    q: this.str,
                    fc: this.fc,
                    ds: ds
                }
            }
            let _this = this
            this.analysisData({data: data,handle(res) {
                if(!res.success) {
                    if(res.total > res.maxCount) {
                        _this.$message({
                            type: 'info',
                            message: '数据过大，分析数据量不能超过'+ res.maxCount+'条'
                        })
                    }
                    return false
                }
                // _this.initData()
                let filedList =['ipc3-applicationYear','ipc3-publicationYear','ipc3-countryCode','ipc3-province','ipc3-city','mainIpc3-applicationYear','mainIpc3-publicationYear','mainIpc3-countryCode',
                'mainIpc3-province','mainIpc3-city','applicant-applicationYear','applicant-publicationYear','applicant-ipc3','applicant-level',
                'inventor-ipc3','countryCode-applicationYear','countryCode-publicationYear','countryCode-ipc3','province-applicationYear','province-publicationYear','agency-ipc3','agent-ipc3']
                if(filedList.indexOf(fieldKey)>-1) {
                    let data1 = res.map
                    let info = {}
                    if(data1&&data1.length>0) {
                        info = data1.slice(0,5)
                    }
                    chartType(mychart,chartDom,info,name)
                }else {
                    let data = [{
                        key: '',
                        value: res.resultMap
                    }]
                    let info = data
                    chartType(mychart,chartDom,info,name)
                }
            }})
        },
        getData() {  
            this.showTable = false
            if(!this.fieldKey) {
                this.fieldLabel = '概览分析'
                this.outLine = true
                this.getOutline()
                return false
            }else {
                this.outLine = false
                this.stepNum = 5
            }
            let field = ''
            let subField = ''
            let ds = 'cn'
            if(this.fieldKey.indexOf('-')>-1) {
                field = this.fieldKey.split('-')[0]
                subField = this.fieldKey.split('-')[1]
            }else {
                field = this.fieldKey
            }
            if(this.fieldKey.indexOf("province")>-1 || this.fieldKey.indexOf("city")>-1 || this.fieldKey=='type') {
                ds = 'cn'
            }
            let data = {
                params: {
                    column: this.columnKey || 'trend',
                    field: field || 'applicationYear',
                    subField: subField,
                    ipcLevel: '3',
                    wfId: this.wfId,
                    size: '50',
                    subSize: '',
                    m: 'none',
                    q: this.str,
                    fc: this.fc,
                    ds: ds,
                    q2: this.q2
                }
            }
            let _this = this
            this.analysisData({data: data,handle(res) {
                if(!res.success) {
                    if(res.total > res.maxCount) {
                        _this.$message({
                            type: 'info',
                            message: '数据过大，分析数据量不能超过'+ res.maxCount+'条'
                        })
                    }
                    return false
                }
                _this.initData()
                let data = []
                let axis = []
                let legend = []
                let newData = {}
                let otherKey = ''
                if(_this.columnKey == 'other') {
                    if(res.map&&res.map.length>0) {
                        otherKey = 'other1'
                    }
                    if(res.resultMap) {
                        otherKey = 'other2'
                    }
                }
                let filedList =['ipc3-applicationYear','ipc3-publicationYear','ipc3-countryCode','ipc3-province','ipc3-city','mainIpc3-applicationYear','mainIpc3-publicationYear','mainIpc3-countryCode',
                'mainIpc3-province','mainIpc3-city','applicant-applicationYear','applicant-publicationYear','applicant-ipc3','applicant-level',
                'inventor-ipc3','countryCode-applicationYear','countryCode-publicationYear','countryCode-ipc3','province-applicationYear','province-publicationYear','agency-ipc3','agent-ipc3']
                if(filedList.indexOf(_this.fieldKey)>-1 || otherKey=='other1') {
                    _this.ipcList = []
                    let data1 = res.map
                    _this.totalData1 = data1
                    if(data1&&data1.length>0) {
                        _this.newData = data1
                    }
                    _this.multiple = 2
                    if(_this.fieldDefault == 'barChart') {
                        _this.barChart()
                    }else if(_this.fieldDefault == 'pieChart') {
                        _this.pieChart()
                    }else {
                        _this.lineChart()
                    }
                    let xAxis = []
                    let types = []
                    let tableData = []
                    _this.totalData1.forEach((item)=>{
                        if(types.indexOf(item.key)<0) {
                            types.push(item.key)
                        }
                        let values = item.value
                        let tableLine = {}
                        if(values.length>0) {
                            values.forEach((item1)=>{
                                tableLine[item1.key] = item1.value
                                if(xAxis.indexOf(item1.key)<0) {
                                    xAxis.push(item1.key)
                                }
                            })
                        }
                        tableData.push({
                            key: item.key,
                            value: tableLine
                        })
                    })
                    _this.multipleType = types
                    _this.multipleXAxis = xAxis
                    _this.tableTd = xAxis
                    _this.tableData = tableData
                    //处理表格导出
                    let excelKey = []
                    let xkey = []
                    data1.forEach((item)=>{
                        excelKey.push(item.key)
                        _this.json_fields1[item.key] = item.key
                        let list = item.value
                        list.forEach((item1)=>{
                            if(xkey.indexOf(item1.key)<0) {
                                xkey.push(item1.key)
                            }
                        })
                    })
                    let excelTable = []
                    xkey.forEach((year)=>{
                        let temp = {}
                        temp.year = year
                        data1.forEach((item1)=>{
                            let key = item1.key
                            let list1 = item1.value
                            let flag = false
                            list1.forEach((item2)=>{
                                if(item2.key == year) {
                                    flag = true
                                    temp[key] = item2.value
                                }
                            })
                            if(!flag) {
                                temp[key] = 0
                            }
                        })
                        excelTable.push(temp)
                    })
                    _this.excelTable = excelTable
                }else {
                    if(_this.fieldKey == 'ipc3' || _this.fieldKey == 'mainIpc3') {
                        if(res.ipcList) {
                            _this.ipcList = res.ipcList
                        }else {
                            _this.ipcList = []
                        }
                    }else {
                        _this.ipcList = []
                    }
                    _this.totalData = res.resultMap
                    data = res.resultMap
                    data.forEach((item)=>{
                        axis.push(item.key)
                    })
                    data.sort(function(a,b){
                        return a.key-b.key;
                    })
                    axis.sort(function(a,b){
                        return a-b;
                    })
                    _this.multipleXAxis = axis
                    _this.data.legend = []
                    _this.data.xAxis = axis
                    _this.data.total = data
                    _this.multiple = 1
                    if(_this.fieldDefault == 'barChart') {
                        _this.barChart()
                    }else if(_this.fieldDefault == 'pieChart') {
                        _this.pieChart()
                    }else {
                        _this.lineChart()
                    }
                }
            }})
        },
        initData() {
            this.totalData = []
            this.totalData1 = []
            this.isIndeter =  false
            this.selAll = false
            this.multipleType = []
            this.multipleXAxis = []
            this.typesKeys = []
            this.isIndeter1= false
            this.selAll1 = false
            this.xAxisKeys = []
            this.isIndeter2 = false
            this.selAll2 = false
            this.timeKeys = ''
            this.time1 = ''
            this.time2 = ''
        },
        filterChartData() {
            let xAxis = []
            xAxis = this.totalData.map((item)=>{
                return item.key
            })
            xAxis = xAxis.sort((a,b)=>{
                return a-b
            })
            let length = xAxis.length
            if(this.multiple == 1) {
                let newData = this.totalData
                if(this.timeKeys) {
                    if(this.timeKeys != 'all') {
                        if(this.timeKeys == '20') {
                            xAxis = xAxis.slice(length-20,length)
                        }
                        if(this.timeKeys == '10') {
                            xAxis = xAxis.slice(length-10,length)
                        }
                        if(this.timeKeys == 'custom') {
                            let index1 = xAxis.indexOf(this.time1)
                            let index2 = xAxis.indexOf(this.time2)
                            xAxis = xAxis.slice(index1,index2+1)
                        }
                        this.totalData.forEach((item)=>{
                            if(xAxis.indexOf(item.key)>-1) {
                                newData.push(item)
                            }
                        })
                        newData.sort((a,b)=>{
                            return a.key - b.key
                        })
                    }else {
                        newData = this.totalData.sort((a,b)=>{
                            return a.key - b.key
                        })
                    }
                }
                if(this.ipcKeys&&this.ipcKeys.length>0) {
                    xAxis = xAxis.filter((item)=>{
                       return this.ipcKeys.indexOf(item)>-1
                    })
                    console.log('xAxis', xAxis)
                    this.totalData.forEach((item)=>{
                        if(this.ipcKeys.indexOf(item.key)>-1) {
                            newData.push(item)
                        }
                    })
                    newData.sort((a,b)=>{
                        return a.key - b.key
                    })
                }
                if(this.xAxisKeys&&this.xAxisKeys.length>0) {
                    xAxis = xAxis.filter((item)=>{
                       return this.xAxisKeys.indexOf(item)>-1
                    })
                    this.totalData.forEach((item)=>{
                        if(this.xAxisKeys.indexOf(item.key)>-1) {
                            newData.push(item)
                        }
                    })
                    newData.sort((a,b)=>{
                        return a.key - b.key
                    })
                }
                this.data.legend = []
                this.data.xAxis = xAxis
                this.data.total = newData
                // this.lineChart()
                if(this.fieldDefault == 'barChart') {
                    this.barChart()
                }else if(this.fieldDefault == 'pieChart') {
                    this.pieChart()
                }else {
                    this.lineChart()
                }
            }else {
                let newData = []
                let tableData = []
                let xAxis = this.multipleXAxis
                let types = this.multipleType
                let length = this.multipleXAxis.length
                xAxis = xAxis.sort((a,b)=>{
                    return a-b
                })
                if(this.timeKeys) {
                    if(this.timeKeys != 'all') {
                        if(this.timeKeys == '20') {
                            xAxis = this.multipleXAxis.slice(length-20,length)
                        }
                        if(this.timeKeys == '10') {
                            xAxis =  this.multipleXAxis.slice(length-10,length)
                        }
                        if(this.timeKeys == 'custom') {
                            let index1 =  this.multipleXAxis.indexOf(this.time1)<0?0:this.multipleXAxis.indexOf(this.time1)
                            let index2 =  this.multipleXAxis.indexOf(this.time2)<0?0:this.multipleXAxis.indexOf(this.time2)
                            xAxis = this.multipleXAxis.slice(index1,index2+1)
                        }
                    }else {
                        xAxis = this.multipleXAxis
                    }
                }
                if(this.xAxisKeys&&this.xAxisKeys.length>0) {
                    xAxis = this.xAxisKeys
                }
                if(this.typesKeys&&this.typesKeys.length>0) {
                    types = this.typesKeys
                }
                this.tableTd = xAxis
                this.totalData1.forEach((item)=>{
                    if(types.indexOf(item.key)>-1) {
                        let values = item.value
                        let arr = []
                        let temp1 = {}
                        if(values.length>0) {
                            values.forEach((item1)=>{
                                if(xAxis.indexOf(item1.key)>-1) {
                                    arr.push(item1)
                                    temp1[item1.key] = item1.value
                                }
                            })
                        }
                        let temp = {
                            key: item.key,
                            value: arr
                        }
                        let tableLine = {
                            key: item.key,
                            value: temp1
                        }
                        newData.push(temp)
                        tableData.push(tableLine)
                    } 
                })
                this.newData = newData
                this.tableData = tableData
                // this.lineChart()
                if(this.fieldDefault == 'barChart') {
                    this.barChart()
                }else if(this.fieldDefault == 'pieChart') {
                    this.pieChart()
                }else {
                    this.lineChart()
                }
            }
        },
        getName(key) {
            let name = ''
            this.totalList.forEach((item)=>{
                if(item.key == key) {
                    name = item.label
                }
            })
            this.name  = name
        },
        initChart() {
            this.myChart = echarts.init(document.getElementById("chart_class"));
            window.addEventListener("resize", () => {
                this.myChart.resize();
            });
        },
        lineChart() {
            this.fieldDefault = 'lineChart'
            let time = 300
            if(this.showTable) {
                this.showTable = false
                time = 600
            }
            this.myChart.dispose()
            setTimeout(()=>{ 
                this.initChart()
                if(this.multiple === 1) {
                    this.lineOption = {
                        color: ['#0095ff','#3fafff','#7fcaff','#ff6836','#ff895d','#ffb217','#ffcf6d','#ffe2a8'],
                        graphic: [
                            {
                                type: 'group',
                                rotation: 0,
                                bounding: 'raw',
                                right: '50%',
                                bottom:'50%',
                                zlevel: 1,
                                children: [
                                    {
                                        type: 'text',
                                        left: 'center',
                                        top: 'center',
                                        // z: 100,
                                        style: {
                                            fill: '#f2f5fa',
                                            text: 'IPRDB.COM',
                                            font: 'bold 46px sans-serif'
                                        }
                                    }
                                ]
                            },
                        ],
                        tooltip: {
                            trigger: 'axis',
                            transitionDuration: 0,
                            axisPointer: {
                                type: 'cross',
                                crossStyle: {
                                    color: '#999'
                                }
                            },
                            enterable: true
                            // triggerOn: 'click',
                        },
                        xAxis: {
                            show: true,
                            type: 'category',
                            data: this.data.xAxis,
                            axisLabel: {
                                show: true,
                                rotate: 50,
                                color: '#777C8B',
                            },
                            nameTextStyle: {
                                width: 16,
                                height: 20,
                                overflow: 'truncate',
                                lineOverflow: 'truncate'
                            },
                            axisLine: {  
                                lineStyle: {
                                    color: '#777C8B'
                                } 
                            },
                            axisTick: {
                                lineStyle: {
                                    color: '#777C8B'
                                } 
                            }
                        },
                        yAxis: {
                            show: true,
                            type: 'value',
                            axisLabel: {
                                color: '#777C8B',
                            },
                            axisLine: {  
                                lineStyle: {
                                    color: '#777C8B'
                                } 
                            },
                            axisTick: {
                                lineStyle: {
                                    color: '#777C8B'
                                } 
                            }
                        },
                        series:
                        [{
                            data: this.data.total,
                            type: 'line',
                            itemStyle: {
                                color: ['#1080FF']
                            }
                        }]
                    }
                }else {
                    let res =  dataTransLate('line',this.newData)
                    this.data.legend = res.legend
                    this.data.xAxis = res.axis
                    this.data.total = res.data
                this.lineOption = {
                    color: ['#0095ff','#3fafff','#7fcaff','#ff6836','#ff895d','#ffb217','#ffcf6d','#ffe2a8'],
                    graphic: [
                            {
                                type: 'group',
                                rotation: 0,
                                bounding: 'raw',
                                right: '50%',
                                bottom:'50%',
                                zlevel: 1,
                                children: [
                                    {
                                        type: 'text',
                                        left: 'center',
                                        top: 'center',
                                        // z: 100,
                                        style: {
                                            fill: '#f2f5fa',
                                            text: 'IPRDB.COM',
                                            font: 'bold 46px sans-serif'
                                        }
                                    }
                                ]
                            },
                        ],
                        tooltip: {
                            trigger: 'axis',
                            transitionDuration: 0,
                            axisPointer: {
                                type: 'cross',
                                crossStyle: {
                                    color: '#999'
                                }
                            },
                            confine: true,
                            formatter: function (params) {
                                if (params instanceof Array) {
                                let str = '';
                                str += `${params[0].axisValue}<br/>`;
                                params.forEach((m, index) => {
                                    str +=  `<span class="chart-tooltip-color" style="display: inline-block; margin-right: 10px; background-color: ${m.color}; width: 10px; height: 10px; border-radius:100%; margin-right: 5px"></span>`;
                                    str += `${m.seriesName}：${m.value}`;
                                    str += `${index % 5 === 0 ? '<br/>' : ''}`; //一排放几个可根据实际情况改变
                                });
                                return str;
                                }
                            },
                            // triggerOn: 'click',
                        },
                        legend: {
                            data: this.data.legend,
                            type: 'scroll',
                            top: 10
                        },
                        grid: {
                            left: '3%',
                            right: '4%',
                            bottom: '3%',
                            containLabel: true
                        },
                        toolbox: {
                            feature: {
                                // saveAsImage: {}
                            }
                        },
                        xAxis: {
                            show: true,
                            type: 'category',
                            boundaryGap: false,
                            data: this.data.xAxis,
                            axisLabel: {
                                show: true,
                                rotate: 50,
                            }
                        },
                        yAxis: {
                            show: true,
                            type: 'value'
                        },
                        series: this.data.total
                    }
                }
                this.myChart.setOption(this.lineOption);
            },time)
        },
        barChart() {
            this.fieldDefault = 'barChart'
            let time = 0
            if(this.showTable) {
                this.showTable = false
                time = 600
            }
            this.myChart.dispose()
            setTimeout(()=>{ 
                this.initChart()
                if(this.multiple == 1) {
                    this.barOption = {
                        color: ['#0095ff','#3fafff','#7fcaff','#ff6836','#ff895d','#ffb217','#ffcf6d','#ffe2a8'],
                        graphic: [
                            {
                                type: 'group',
                                rotation: 0,
                                bounding: 'raw',
                                right: '50%',
                                bottom:'50%',
                                zlevel: 1,
                                children: [
                                    {
                                        type: 'text',
                                        left: 'center',
                                        top: 'center',
                                        // z: 100,
                                        style: {
                                            fill: '#f2f5fa',
                                            text: 'IPRDB.COM',
                                            font: 'bold 46px sans-serif'
                                        }
                                    }
                                ]
                            },
                        ],
                        tooltip: {
                            trigger: 'item',
                            transitionDuration: 0,
                            axisPointer: {
                                type: 'cross',
                                crossStyle: {
                                    color: '#999'
                                }
                            },
                            // triggerOn: 'click',
                        },
                        xAxis: {
                            show: true,
                            type: 'category',
                            data: this.data.xAxis,
                            axisLine: {  
                                lineStyle: {
                                    color: '#777C8B'
                                } 
                            },
                            axisTick: {
                                lineStyle: {
                                    color: '#777C8B'
                                } 
                            }
                        },
                        yAxis: {
                            show: true,
                            type: 'value',
                            axisLine: {  
                                lineStyle: {
                                    color: '#777C8B'
                                } 
                            },
                            axisTick: {
                                lineStyle: {
                                    color: '#777C8B'
                                } 
                            }
                        },
                        series: [{
                            data: this.data.total,
                            type: 'bar',
                            showBackground: true,
                            backgroundStyle: {
                                color: 'rgba(220, 220, 220, 0.8)'
                            },
                            itemStyle: {
                                color: ['#1080FF']
                            }
                        }]
                    }
                }else {
                    let res =  dataTransLate('bar',this.newData)
                    this.data.legend = res.legend
                    this.data.xAxis = res.axis
                    this.data.total = res.data
                    this.barOption = {
                        color: ['#0095ff','#3fafff','#7fcaff','#ff6836','#ff895d','#ffb217','#ffcf6d','#ffe2a8'],
                        graphic: [
                            {
                                type: 'group',
                                rotation: 0,
                                bounding: 'raw',
                                right: '50%',
                                bottom:'50%',
                                zlevel: 1,
                                children: [
                                    {
                                        type: 'text',
                                        left: 'center',
                                        top: 'center',
                                        // z: 100,
                                        style: {
                                            fill: '#f2f5fa',
                                            text: 'IPRDB.COM',
                                            font: 'bold 46px sans-serif'
                                        }
                                    }
                                ]
                            },
                        ],
                        tooltip: {
                            trigger: 'axis',
                            transitionDuration: 0,
                            axisPointer: {
                                type: 'cross',
                                crossStyle: {
                                    color: '#999'
                                }
                            },
                            confine: true,
                            formatter: function (params) {
                                if (params instanceof Array) {
                                let str = '';
                                str += `${params[0].axisValue}<br/>`;
                                params.forEach((m, index) => {
                                    str +=  `<span class="chart-tooltip-color" style="display: inline-block; margin-right: 10px; background-color: ${m.color}; width: 10px; height: 10px; border-radius:100%; margin-right: 5px"></span>`;
                                    str += `${m.seriesName}：${m.value}`;
                                    str += `${index % 5 === 0 ? '<br/>' : ''}`; //一排放几个可根据实际情况改变
                                });
                                return str;
                                }
                            },
                            // triggerOn: 'click',
                        },
                        legend: {
                            data: this.data.legend,
                            type: 'scroll',
                            top: 10
                        },
                        grid: {
                            left: '3%',
                            right: '4%',
                            bottom: '3%',
                            containLabel: true
                        },
                        xAxis: {
                            show: true,
                            type: 'category',
                            data: this.data.xAxis,
                            axisLabel: {
                                show: true,
                                rotate: 50,
                            }
                        },
                        yAxis: {
                            show: true,
                            type: 'value'
                        },
                        series: this.data.total
                    }

                }
                this.myChart.setOption(this.barOption);
            },time)
        },
        pieChart() {
            this.fieldDefault = 'pieChart'
            let time = 0
            if(this.showTable) {
                this.showTable = false
                time = 600
            }
            this.myChart.dispose()
            setTimeout(()=>{ 
                this.initChart()
                this.pieOption = {
                    color: ['#0095ff','#3fafff','#7fcaff','#ff6836','#ff895d','#ffb217','#ffcf6d','#ffe2a8'],
                    graphic: [
                        {
                            type: 'group',
                            rotation: 0,
                            bounding: 'raw',
                            right: '50%',
                            bottom:'50%',
                            zlevel: 1,
                            children: [
                                {
                                    type: 'text',
                                    left: 'center',
                                    top: 'center',
                                    // z: 100,
                                    style: {
                                        fill: '#f2f5fa',
                                        text: 'IPRDB.COM',
                                        font: 'bold 46px sans-serif'
                                    }
                                }
                            ]
                        },
                    ],
                    xAxis: {
                    show: false
                    },
                    yAxis: {
                        show: false
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b}: {c}',
                        transitionDuration: 0,
                        axisPointer: {
                            type: 'cross',
                            crossStyle: {
                                color: '#999'
                            }
                        },
                        // triggerOn: 'click',
                    },
                    legend: {
                        orient: 'vertical',
                        left: 10,
                        data: this.data.xAxis
                    },
                    series: [
                        {
                            name: '申请数',
                            type: 'pie',
                            radius: ['50%', '70%'],
                            // itemStyle: {
                            //     normal: {
                            //         color:function(params) {
                            //         //自定义颜色
                            //             var colorList = [   
                            //                 '#1080FF',        
                            //                 '#C1232B','#B5C334','#FCCE10','#E87C25','#27727B',                                    
                            //                 '#FE8463','#9BCA63','#FAD860','#F3A43B','#60C0DD',                                            
                            //             ];
                            //             return colorList[params.dataIndex]
                            //         }
                            //     }
                            // },
                            avoidLabelOverlap: false,
                            label: {
                                show: false,
                                position: 'center'
                            },
                            emphasis: {
                                label: {
                                    show: true,
                                    fontSize: '30',
                                    fontWeight: 'bold'
                                }
                            },
                            labelLine: {
                                show: false
                            },
                            data: this.data.total
                        }
                    ]
                }
                this.myChart.setOption(this.pieOption);
            },time)
        },
        insideBar() {
            this.fieldDefault = 'insideBar'
            let time = 0
            if(this.showTable) {
                this.showTable = false
                time = 600
            }
            this.myChart.dispose()
            setTimeout(()=>{ 
                this.initChart()
                let insideOption = {
                    color: ['#0095ff','#3fafff','#7fcaff','#ff6836','#ff895d','#ffb217','#ffcf6d','#ffe2a8'],
                    graphic: [
                        {
                            type: 'group',
                            rotation: 0,
                            bounding: 'raw',
                            right: '50%',
                            bottom:'50%',
                            zlevel: 1,
                            children: [
                                {
                                    type: 'text',
                                    left: 'center',
                                    top: 'center',
                                    // z: 100,
                                    style: {
                                        fill: '#f2f5fa',
                                        text: 'IPRDB.COM',
                                        font: 'bold 46px sans-serif'
                                    }
                                }
                            ]
                        },
                    ],
                    tooltip: {
                        trigger: 'axis',
                        // axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        //     type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                        // },
                        transitionDuration: 0,
                        axisPointer: {
                            type: 'cross',
                            crossStyle: {
                                color: '#999'
                            }
                        },
                        // triggerOn: 'click',
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: [
                        {
                            show: true,
                            type: 'value',
                            axisLine: {  
                                lineStyle: {
                                    color: '#777C8B'
                                } 
                            },
                            axisTick: {
                                lineStyle: {
                                    color: '#777C8B'
                                } 
                            }
                        }
                    ],
                    yAxis: [
                        {
                            show: true,
                            type: 'category',
                            axisTick: {
                                show: false,
                                lineStyle: {
                                    color: '#777C8B'
                                } 
                            },
                            data: this.data.xAxis,
                            axisLine: {  
                                lineStyle: {
                                    color: '#777C8B'
                                } 
                            }
                        }
                    ],
                    series: [
                        {
                            name: '数值',
                            type: 'bar',
                            itemStyle: {
                                color: ['#1080FF']
                            },
                            label: {
                                show: true,
                                position: 'inside'
                            },
                            data: this.data.total
                        }
                    ]
                }
                this.myChart.setOption(insideOption);
            },time)
        },
        lineChart1(myChart,chartDom,newData,name) {
            if(myChart) {
                myChart.dispose()
            }
            myChart = echarts.init(chartDom);
            window.addEventListener("resize", () => {
                myChart.resize();
            });
            let res =  dataTransLate('line',newData)
            let data = {}
            data.legend = res.legend.length>1? res.legend: []
            data.xAxis = res.axis
            data.total = res.data
            let lineOption = {
                title: {
                    show: true,
                    text: name
                },
                color: ['#0095ff','#3fafff','#7fcaff','#ff6836','#ff895d','#ffb217','#ffcf6d','#ffe2a8'],
                graphic: [
                        {
                            type: 'group',
                            rotation: 0,
                            bounding: 'raw',
                            right: '50%',
                            bottom:'50%',
                            zlevel: 1,
                            children: [
                                {
                                    type: 'text',
                                    left: 'center',
                                    top: 'center',
                                    // z: 100,
                                    style: {
                                        fill: '#f2f5fa',
                                        text: 'IPRDB.COM',
                                        font: 'bold 46px sans-serif'
                                    }
                                }
                            ]
                        },
                    ],
                tooltip: {
                    trigger: 'axis',
                    transitionDuration: 0,
                    axisPointer: {
                        type: 'cross',
                        crossStyle: {
                            color: '#999'
                        }
                    },
                    // triggerOn: 'click',
                },
                    legend: {
                        data: data.legend,
                        type: 'scroll',
                        top: 28
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    toolbox: {
                        feature: {
                            // saveAsImage: {}
                        }
                    },
                    xAxis: {
                        show: true,
                        type: 'category',
                        boundaryGap: false,
                        data: data.xAxis,
                        axisLabel: {
                            show: true,
                            rotate: 50,
                        }
                    },
                    yAxis: {
                        show: true,
                        type: 'value'
                    },
                    series: data.total
            }
            myChart.setOption(lineOption);
        },
        saveRation() {
            this.openSaveDialog = true
            this.proInfo = {
                id: this.projectId,
                name: this.currentName,
                cover: this.cover
            }
        },
        watchSaDialog(val) {
            this.openSaveDialog = val
        }
    }
}
</script>